import { render, staticRenderFns } from "./attributes-editor.vue?vue&type=template&id=23698bc2"
import script from "./attributes-editor.vue?vue&type=script&lang=js"
export * from "./attributes-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports